export const routerPath = {
  main: '/',
  // General
  settings: '/settings',
  login: '/login',
  confirmEmail: '/confirm-email',
  setPassword: '/set-password',
  activate: '/activate',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  staffProfile: '/staff/:staffId',
  profile: '/profile',
  chats: '/chats',
  blog: '/blog/:slug',
  pushNotifications: '/notifications',
  certificate: 'certificates/:certificateId',
  profileRequestCreate: 'request/create',
  profileAttendanceRequestCreate: 'request/create/attendance',
  profileRequestDetail: 'requests/:requestId',
  teacherProfileRequestCreate: 'teacher/request/create',
  teacherProfileRequestDetail: 'teacher/requests/:requestId',

  // Student
  enrollments: '/enrollments',
  enrollment: ':enrollmentId',
  enrollment_terms: 'terms/:intakeTermId',
  enrollment_group_lesson:
    'terms/:intakeTermId/modules/:intakeModuleId/groups/:groupNumber/groupLesson/:groupLessonId',
  enrollment_group_exam_resubmission:
    'terms/:intakeTermId/modules/:intakeModuleId/groups/:groupNumber/groupExamResubmission/:groupExamResubmissionId',
  assignments: '/assignments',
  assignmentGroupLesson: 'groupLesson/:groupLessonId',
  assignmentExamResubmission: 'groupExamResubmission/:groupExamResubmissionId',
  catalogue: '/catalogue',
  course: '/catalogue/course/:courseId',
  calendar: '/calendar',

  // Teacher
  teacherAssignments: '/teacher/assignments',
  teacherAssignmentDetailsGroupLesson: 'group-lesson/:groupLessonId',
  teacherAssignmentDetailsGroupExamResubmission:
    'group-exam-resubmission/:groupExamResubmissionId',
  teacherGroupLessonAssessment:
    'group-lesson-assessment/:groupLessonId/enrollment/:enrollmentId',
  teacherGroupExamResubmissionAssessment:
    'group-exam-resubmission-assessment/:groupExamResubmissionId/enrollment/:enrollmentId',

  teacherCourses: '/teacher/courses',
  teacherCourse: '/teacher/courses/:courseId',
  teacherIntake: '/teacher/intakes/:intakeId',
  teacherIntakeGroups: '/teacher/intakes/:intakeId/groups/:groupNumber',
  teacherGroupTerm: '/teacher/intakes/:intakeId/groups/:groupNumber/terms/:intakeTermId',
  teacherCourseGroup: '/teacher/courses/:courseId/intakes/:intakeId/groups/:groupNumber',
  teacherCourseGroupTerm: '/teacher/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId',
  // Course flow: modules/lessons/attendance/lesson nested under teacher/courses/.../terms/:termId
  teacherCourseGroupTermModuleLessons:
    '/teacher/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:intakeModuleId/lessons',
  teacherCourseGroupTermModuleAttendance:
    '/teacher/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:intakeModuleId/attendance',
  teacherCourseGroupTermModuleLesson:
    '/teacher/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:intakeModuleId/lesson',
  // Standalone (e.g. from teacher/assignments flow) — not nested under teacher/courses
  teacherModuleLessons: '/teacher/modules/:intakeModuleId/groups/:groupNumber/lessons',
  teacherModuleAttendance: '/teacher/modules/:intakeModuleId/groups/:groupNumber/attendance',
  teacherLesson: '/teacher/modules/:intakeModuleId/groups/:groupNumber/lesson',

  // Not Found
  not_found: '*',
} as const;

export type TypeRouterPath = (typeof routerPath)[keyof typeof routerPath];
